module.exports = __webpack_public_path__ + "assets/htu-7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-7.png
// module id = 1653
// module chunks = 7